import { createContext, createElement, useContext } from 'react';

export const BOOK_TOOLS_EVENT = 'brainstormy-book-tool';

const EMPTY_BOOK_TOOLS = {
  activeId: null,
  available: false,
  namesEnabled: false,
  referenceEnabled: false,
  progressEnabled: false,
  select() {},
};

const BookToolsContext = createContext(EMPTY_BOOK_TOOLS);

export function BookToolsProvider({ value, children }) {
  return createElement(
    BookToolsContext.Provider,
    { value: value || EMPTY_BOOK_TOOLS },
    children,
  );
}

export function useBookTools() {
  return useContext(BookToolsContext);
}

/** Ask the layout to open or close one right-slot tool. */
export function publishBookTool(id) {
  window.dispatchEvent(new CustomEvent(BOOK_TOOLS_EVENT, { detail: id }));
}

/**
 * Closing a Book tool on Outline or Scene writing leaves chat as the
 * writer left it. Other rooms are unchanged: a tool close does not
 * open chat. Idea closes the panel. A phone has no slot, so the fold
 * flag stays put.
 */
export function bookToolShouldUnfoldChat(pathname, mobile) {
  if (mobile) return false;
  const path = pathname || '';
  if (path.startsWith('/plottrack') || path.startsWith('/scene-writing')) return false;
  return false;
}
